export default "__VITE_ASSET__BVrKbR9x__"